import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import i18n from '../../mixins/i18n';

import messengerIcon from '../../assets/messages/messenger.png';
import smsIcon from '../../assets/messages/sms.png';
import twitterIcon from '../../assets/messages/twitter.png';
import whatsappIcon from '../../assets/messages/whatsapp.png';
import widgetIcon from '../../assets/messages/widget.png';

const channelsInfo = {
  webchat: {
    icon: widgetIcon,
    title: 'AgentIQ webchat',
  },
  widget: {
    icon: widgetIcon,
    title: 'AgentIQ widget',
  },
  twitter: {
    icon: twitterIcon,
    title: 'Twitter Direct Messages',
  },
  sms: {
    icon: smsIcon,
    title: 'SMS',
  },
  messenger: {
    icon: messengerIcon,
    title: 'Facebook messenger',
  },
  facebook: {
    icon: messengerIcon,
    title: 'Facebook messenger',
  },
  whatsapp: {
    icon: whatsappIcon,
    title: 'Whatsapp',
  },
};

const handleClick = (_window, _url, e) => {
  _window.open(_url);
  e.preventDefault();
};

const getInitials = (first, last) => [(first || '').toUpperCase()[0], (last || '').toUpperCase()[0]]
  .join('')
  .trim();

const urlMatcher = /\b(href=["‘'])?(((https?:\/\/|www\d{0,3}[.]|[a-z0-9.-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]|(\([^\s()<>]+\)))*\)|[^\s`!()[\]{};:'".,<>?«»“”‘’])))/ig;

const urlFilter = value =>
  value.replace(urlMatcher, function (match, hrefGroup) {   // eslint-disable-line
    // Do not change link starting with href=" to avoid anchor link
    return hrefGroup ? match : `<a target="_self" href="javascript:void(0)" id="aiq-link" rel="noopener">${match}</a>`;
  });

// should match youtube or vimeo link to extract
// service name & video id
const youtubeRegex = /(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/(watch\?v=|embed\/){0,1}([a-zA-Z0-9_-]+)/g; // eslint-disable-line
const vimeoRegex = /(https?\:\/\/)?((www\.){0,1}vimeo\.com|player.vimeo.com)\/(video\/){0,1}([a-zA-Z0-9_-]+)/g; // eslint-disable-line
const detectVideos = function (v) {
  if (!v) {
    return [];
  }

  return uniqBy([
    ...[...v.matchAll(youtubeRegex)].map(match => ['youtube', match[4]]),
    ...[...v.matchAll(vimeoRegex)].map(match => ['vimeo', match[5]]),
  ], (n) => n[1]);
};

/**
 * Make video embeding iframe
 *
 * @param video Array[(youtube|vimeo), id]
 * @param title String
 * @return string - html string that has iframe with video url
 */
const embedVideoHtml = function (video, senderType, senderName) {
  if (!video || !(video instanceof Array)) {
    return '';
  }

  const type = get(video, '0');
  const id = get(video, '1');
  if (!type || !id) {
    return '';
  }

  let videoUrl;
  if (type === 'vimeo') {
    videoUrl = `https://player.vimeo.com/video/${id}`;
  } else {
    videoUrl = `https://www.youtube.com/embed/${id}`;
  }

  const senderRole = senderType.slice(0, -1);
  const defaultValue = `${type} video sent by ${senderRole} ${senderName}`;
  const iframeTitle = i18n.methods.getString(
    `screen.chat.${senderType}_video_iframe_title`,
    { defaultValue, type, name: senderName },
  );

  // TODO: configuration for iframe may get customized here in future
  return `<iframe src="${videoUrl}"
           frameborder="0"
           allow="autoplay; fullscreen; picture-in-picture"
           style="margin: 0 auto; display: block; width: 100%; height: 100%;"
           title="${iframeTitle}"
           allowfullscreen></iframe>`;
};

const is = (attachment, type) => {
  if (attachment.message_type === 'url'
      || (attachment.message_type === 'file'
        && get(attachment, 'file.mime_type', '').includes('application/pdf'))) {
    return type === 'document';
  }

  return (type === attachment.message_type);
};

/* eslint-disable no-useless-escape */
const PHONE_REGEX = /((\+|00)?[1-9]?[0-9 \-().\/]{7,32})(?:\s*?(?:#|x\.?|ext\.?|extension)\s*?(\d+))?/gi;
const MIN_PHONE_DIGITS = 10;

const replaceNumberWithLink = (match, phoneNum, _, extNum) => {
  const isPartOfUrl = (match[0] || match[match.length - 1]) === '/';
  const digits = phoneNum.match(/\d/g) || [];
  const extension = extNum ? `;${extNum}` : '';
  return digits.length < MIN_PHONE_DIGITS || isPartOfUrl ? match : ` <a href="tel:${phoneNum + extension}">${match}</a>`;
};

const makePhoneNumbersDialable =
    (message) => message.replace(PHONE_REGEX, replaceNumberWithLink);


export {
  channelsInfo,
  getInitials,
  urlFilter,
  handleClick,
  is,
  detectVideos,
  embedVideoHtml,
  makePhoneNumbersDialable,
};
